export interface DisplayedFittersByDay {
  day: string;
  numberOfDisplayDays: number;
}

export function incrementDisplayedFittersForDay(
  displayedFittersByDay: DisplayedFittersByDay[],
  day: string,
  increment = 2
): void {
  const displayedFittersForDay = displayedFittersByDay.find(
    (item) => item.day === day
  );

  if (displayedFittersForDay) {
    displayedFittersForDay.numberOfDisplayDays += increment;
  }
}

export function shouldShowMoreFittersForDay(
  hasCachedFitters: boolean,
  displayedFitters: number,
  availableFitters: number
): boolean {
  return hasCachedFitters || displayedFitters < availableFitters;
}
